module.exports = __webpack_public_path__ + "img/preload.b1563ec5.svg";